import jsPDF from 'jspdf';
import * as XLSX from "xlsx"
import { format } from "date-fns"
import { COLUMN_TYPE } from "../components/NextUITable.jsx"
import { faDove } from '@fortawesome/free-solid-svg-icons';
//import("jspdf-autotable")
import { autoTable } from "jspdf-autotable"
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const stickyBottomClass = 'z-[50] bg-white mb-5  sticky bottom-[0px]  px-4 py-2 flex items-center justify-center gap-4'
export const stickyParentClass = 'mb-3  h-[calc(100vh-118px)]  overflow-y-auto'

export const scrollInput = () => {
  const handler = (e) => {
    const target = e.target;

    if (!["INPUT", "SELECT", "TEXTAREA"].includes(target.tagName)) return;

    // Only scroll for keyboard focus (not mouse clicks)
    if (e.detail === 0) { // e.detail === 0 means it wasn't a mouse click
      setTimeout(() => {
        // Check if the element is still in document and visible
        if (document.body.contains(target)) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 200);
    }
  };

  document.addEventListener("focusin", handler);
  return () => document.removeEventListener("focusin", handler);
};

export const funCheckNumber = (val) => {

  if (Number.isNaN(val) || !Number.isFinite(val) || val == "") {
    return 0
  }
  else
    return val
}
// Helper function to split text into lines that fit within a max width
const funGetWrapLineString = (text, maxLength) => {
  const words = text.split(' ');
  let lines = [];
  let currentLine = '';

  words.forEach(word => {
    // Check if adding this word exceeds the max length
    if ((currentLine + word).length <= maxLength) {
      currentLine += word + ' ';  // Add the word to the current line
    } else {
      // If adding the word exceeds the max length, push the current line and start a new one
      lines.push(currentLine.trim());
      currentLine = word + ' ';
    }
  });

  // Push any remaining text in currentLine
  if (currentLine.trim()) {
    lines.push(currentLine.trim());
  }

  return lines;
};



export const getDataSetByGroup = (data) => {
  const groupedItems = data.reduce((result, item) => {
    // Get the category as the key
    let key = item.broker;

    // If the key does not exist in the result, create it as an array
    if (!result[key]) {
      result[key] = [];
    }

    // Push the current item into the corresponding category
    result[key].push(item);

    return result;
  }, {});
  return groupedItems
}
function filterKeys(obj, keys) {
  return keys.reduce((acc, key) => {
    acc[key] = obj[key] || "";
    return acc;
  }, {});
}
export const funGetSubString = (str, length) => {
  if (str && str != "") {
    if (str.length > length)
      return str.substring(0, length) + ".."
    else
      return str
  }
  else
    return str
}

function calculateTotal({ data = [], columnName = "" }) {
  const sum = data?.reduce((accumulator, object) => {
    return Number(accumulator) + Number(object[columnName])
  }, 0)
  return sum.toFixed(2)
}
function calculateTotalWeight({ data = [], columnName = "" }) {
  const sum = data?.reduce((accumulator, object) => {
    return Number(accumulator) + Number(object[columnName])
  }, 0)
  return sum.toFixed(3)
}

export const convertDate = (dateString) => {

  const date = new Date(dateString);

  // Get day, month and year
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');  // Month is 0-indexed, so add 1
  const year = date.getFullYear();

  // Return in desired format
  return `${day}-${month}-${year}`;
};

export const addDaysToDate = (date, daysToAdd) => {
  const newDate = new Date(date); // Create a new Date object to avoid mutating the original date
  newDate.setDate(newDate.getDate() + Number(daysToAdd)); // Add days
  return newDate;
}

function convertToNestedArray({ data }) {
  /* convert array of object to array of array */
  const dataArray = data.length > 0 ? data.map(Object.values) : []
  return dataArray
}

function createColumnArray({ data }) {
  const columnArray = data.length > 0 ? Object.keys(data[0]) : []
  return columnArray
}

function PivotAgingPartyWise(data, selectedAge) {
  let newData = data.map((item) => {
    if (selectedAge.toLowerCase() == "all") {
      return {
        ...item,
        amount:
          item["<=45"] +
          item[">45<=60"] +
          item[">60<=90"] +
          item[">90<=120"] +
          item[">120"],
      }
    }
    else {
      return {
        ...item,
        amount:
          item[selectedAge]
      }
    }
  })
  return newData
}

function PivotDataSummary(data, isPartyWiseAging) {
  let dataArray = convertToNestedArray({ data })
  dataArray = dataArray[0]
  const columnArray = createColumnArray({ data })

  const newData = []
  const totData = []
  //get summary (total) aging wise
  if (!isPartyWiseAging) {
    let totAge1 = 0
    let totAge2 = 0
    let totAge3 = 0
    let totAge4 = 0
    let totAge5 = 0
    if (data && data?.length > 0) {
      for (let j = 0; j < data.length; j++) {
        totAge1 += data[j]["<=45"]
        totAge2 += data[j][">45<=60"]
        totAge3 += data[j][">60<=90"]
        totAge4 += data[j][">90<=120"]
        totAge5 += data[j][">120"]
      }
      totData.push(
        totAge1.toFixed(2),
        totAge2.toFixed(2),
        totAge3.toFixed(2),
        totAge4.toFixed(2),
        totAge5.toFixed(2)
      )
    }
  }
  //end
  for (let i = 0; i < dataArray.length; i++) {
    if (!["party_id", "party"].includes(columnArray[i])) {
      let obj = {
        daysRange: columnArray[i],
        daysRemaning: isPartyWiseAging ? dataArray[i] : totData[i - 2],
        //set index array as condition {party & party Id skip (i-2 to set same index for both )}
        id: i,
      }
      newData.push(obj)
    }
  }
  return newData
}

function pivotData({ data }) {
  let dataArray = convertToNestedArray({ data })
  dataArray = dataArray[0]
  const columnArray = createColumnArray({ data })
  const newData = []
  for (let i = 0; i < dataArray.length; i++) {
    if (!["party_id", "party"].includes(columnArray[i])) {
      let obj = {
        daysRange: columnArray[i],
        daysRemaning: dataArray[i],
        id: i,
      }
      newData.push(obj)
    }
  }
  return newData
}

function getExportData({ data, exportColumns }) {
  let exportData = data.map((item) => {
    return exportColumns.reduce((result, column) => {
      let value = item[column.uid]
      if (column.hasOwnProperty("type") && column.type === COLUMN_TYPE.date) {
        value = value ? format(new Date(value), "dd/MM/yyyy") : value
      }
      else if (column.hasOwnProperty("type") && column.type === COLUMN_TYPE.weight) {
        value = value.toFixed(3)
      }
      else if (column.hasOwnProperty("type") && column.type === COLUMN_TYPE.number) {
        value = value.toFixed(2)
      }

      result[column.name] = value
      return result
    }, {})
  })
  return exportData
}

const exportToExcel = ({ data, downloadFileName, exportColumns }) => {
  const exportData = getExportData({ data, exportColumns })
  const worksheet = XLSX.utils.json_to_sheet(exportData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data")
  XLSX.writeFile(workbook, `${downloadFileName}.xlsx`)
}


const exportToExcelWithFilter = async ({
  data,
  downloadFileName,
  exportColumns,
  companyName,
  logo,
  currency = ""
}) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Table Data');

  // === 1. Add image (logo) ===
  if (logo && logo !== "") {
    const imageId = workbook.addImage({
      base64: logo,
      extension: 'jpeg',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 120, height: 60 },
    });

    const logoWidthCols = 2;
    const nameStartCol = logoWidthCols + 1;
    const nameEndCol = exportColumns.length;
    worksheet.mergeCells(1, nameStartCol, 1, nameEndCol);

    const titleCell = worksheet.getCell(1, nameStartCol);
    titleCell.value = companyName;
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getRow(1).height = 50;
  } else {
    worksheet.mergeCells(1, 1, 1, exportColumns.length);
    const titleCell = worksheet.getCell('A1');
    titleCell.value = companyName;
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getRow(1).height = 30;
  }

  // === 2. Add header row ===
  const headerRowIndex = 2;
  worksheet.getRow(headerRowIndex).values = exportColumns.map(col => col.name);
  worksheet.getRow(headerRowIndex).font = { bold: true };

  // === 3. Apply Auto Filter ===
  worksheet.autoFilter = {
    from: { row: headerRowIndex, column: 1 },
    to: { row: headerRowIndex, column: exportColumns.length },
  };

  // === 4. Add data rows with hyperlink in 'videolink' column ===
  data.forEach(item => {
    const rowValues = exportColumns.map(col => {
      let value = item[col.uid];

      if (col.uid === 'videofile' && value) {
        return { text: value, hyperlink: value };
      } else if (col.uid === 'imgfile' && value) {
        return { text: value, hyperlink: value };
      } else if (col.uid === 'certfile' && item["reportno"] != "") {
        const reprtno = item["reportno"];
        const link = item["labid"]
          ? item["labid"].toUpperCase() === "IGI"
            ? `https://www.igi.org/verify-your-report/?r=${reprtno}`
            : item["labid"].toUpperCase() === "GIA"
              ? `https://www.gia.edu/report-check?reportno=${reprtno}`
              : ""
          : "";
        return { text: link, hyperlink: link };
      }
      return value;
    });

    const row = worksheet.addRow(rowValues);

    // Optional: Style hyperlink cell
    row.eachCell((cell, colNumber) => {
      const colUid = exportColumns[colNumber - 1]?.uid;
      if (['videofile', 'imgfile', 'certfile'].includes(colUid) && cell.hyperlink) {
        cell.font = { color: { argb: 'FF0000FF' }, underline: true };
      }
    });

    
    // === Highlight row if price <= 0 ===
    if (currency != 'RS') {
      const priceColIndex = exportColumns.findIndex(col => col.uid === 'brated'); // replace 'price' with actual uid
      if (priceColIndex !== -1 && (item['brated'] <= 0)) {
        row.eachCell(cell => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFC0C0' } // light red
          };
        });
      }
    }
    else {
      const priceColIndex = exportColumns.findIndex(col => col.uid === 'brate'); // replace 'price' with actual uid
      if (priceColIndex !== -1 && (item['brate'] <= 0)) {
        row.eachCell(cell => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFC0C0' } // light red
          };
        });
      }
    }

  });

  // === 5. Total row ===
  const totalRowIndex = headerRowIndex + data.length + 1;
  const totalRow = worksheet.addRow(
    exportColumns.map((col, index) => {
      if (col.type === 'number' || col.type === 'Number') {
        const colLetter = String.fromCharCode(65 + index);
        return { formula: `SUM(${colLetter}${headerRowIndex + 1}:${colLetter}${totalRowIndex - 1})` };
      }
      return index === 0 ? 'Total' : '';
    })
  );
  totalRow.font = { bold: true };

  // === 6. Export to file ===
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  workbook.clearThemes();
  saveAs(blob, `${downloadFileName}.xlsx`);
};



const exportToCSV = ({ data, downloadFileName, exportColumns }) => {
  const exportData = getExportData({ data, exportColumns })

  const worksheet = XLSX.utils.json_to_sheet(exportData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data")
  XLSX.writeFile(workbook, `${downloadFileName}.csv`)
}

const addDataFooter = ({ tempData, downloadDataFooter }) => {
  if (Object.keys(downloadDataFooter).length > 0) {
    return [...tempData, downloadDataFooter]
  }
  return tempData
}

const exportToPDF = ({
  data,
  downloadFileName = "",
  exportColumns,
  exportReportType,
  downloadFileheader = [],
  downloadDataFooter = {},
  companyName = []

}) => {
  if (exportReportType && exportReportType != "" && exportReportType != null) {
    if (exportReportType == "Ledger") {
      exportLedgerReportToPDF({
        data: data,
        downloadFileName: downloadFileName,
        downloadDataFooter: downloadDataFooter,
        exportColumns: exportColumns,
        downloadFileheader: downloadFileheader,
      })
    }
    else {
      exporGridToPDF({
        data: data,
        downloadFileName: downloadFileName,
        downloadDataFooter: downloadDataFooter,
        exportColumns: exportColumns,
        downloadFileheader: downloadFileheader,
        exportReportType: exportReportType,
        companyName: companyName

      })
    }

  }
  else {
    exporGridToPDF({
      data: data,
      downloadFileName: downloadFileName,
      downloadDataFooter: downloadDataFooter,
      exportColumns: exportColumns,
      companyName: companyName,
      downloadFileheader: downloadFileheader,


    })
  }

}

const capitalize = ({ str }) => {
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1)
  }
  return str
}

//outstanding Report
const exportInterestReportToPDF = ({
  data,
  downloadFileName = "",
  exportColumns,
  billType = "",
  reportTitle = "",
  downloadBillDetail = {},
  downloadFileheader = [],
  downloadDataFooter = {},
}) => {
  let exportData = getExportData({ data, exportColumns })
  exportData = addDataFooter({ tempData: exportData, downloadDataFooter })

  const doc = new jsPDF()
  let startX = 3
  /* creating column list */
  const colummArray = createColumnArray({ data: exportData })
  /* copy data as array of array */
  const dataArray = convertToNestedArray({ data: exportData })

  doc.setFontSize(10)
  let startY = 10
  let gapY = 20

  startY = 33;
  gapY = 8

  doc.setFontSize(11)
  if (downloadFileheader.length > 0) {
    downloadFileheader.map((item, index) => {
      doc.text(`${item.key}: ${item.value}`, 12, gapY)
      startY += 7;
      gapY += 5;
      return 0
    })
  }

  autoTable(doc, {
    theme: "grid",
    body: dataArray,
    head: [colummArray],
    tableWidth: 200,
    margin: 3,
    startY: startY,
    gapY: 50,
    styles: {
      fontSize: 8,
      margin: 0
      //  cellWidth:12

    },

    columnStyles: billType == "Outstanding" ? {
      0: { cellWidth: 15, halign: "center" },
      1: { cellWidth: 18, halign: "center" },
      2: { cellWidth: 18, halign: "right" },
      3: { cellWidth: 18, halign: "right" },
      4: { cellWidth: 11, halign: "right" },
      5: { cellWidth: 11, halign: "right" },
      6: { cellWidth: 10, halign: "right" },
      7: { cellWidth: 18, halign: "center" },
      8: { cellWidth: 13, halign: "center" },
      9: { cellWidth: 18, halign: "center" },
      10: { cellWidth: 13, halign: "center" },
      11: { cellWidth: 10, halign: "center" },
      12: { cellWidth: 13, halign: "right" },
      13: { cellWidth: 18, halign: "right" },
    } : {
      0: { cellWidth: 10, halign: "center" },
      1: { cellWidth: 10, halign: "center" },
      2: { cellWidth: 13, halign: "right" },
      3: { cellWidth: 13, halign: "right" },
      4: { cellWidth: 8, halign: "right" },
      5: { cellWidth: 9, halign: "right" },
      6: { cellWidth: 10, halign: "center" },
      7: { cellWidth: 11, halign: "center" },
      8: { cellWidth: 10, halign: "center" },
      9: { cellWidth: 11, halign: "center" },
      10: { cellWidth: 13, halign: "right" },
      11: { cellWidth: 13, halign: "right" },
      12: { cellWidth: 10, halign: "right" },
      13: { cellWidth: 10, halign: "right" },
      14: { cellWidth: 9, halign: "right" },
      15: { cellWidth: 9, halign: "center" },
      16: { cellWidth: 9, halign: "right" },
      17: { cellWidth: 13, halign: "right" },
      18: { cellWidth: 13, halign: "right" },

    },
    headStyles: {
      fillColor: [46, 128, 186],
      fontSize: 7,
      textColor: [247, 247, 247]

    },
    didParseCell: function (data) {
      if (data.row.index === dataArray.length - 1) {
        data.cell.styles.fillColor =
          Object.keys(downloadDataFooter).length > 0
            ? [46, 128, 186]
            : [255, 255, 255]
        data.cell.styles.fontStyle =
          Object.keys(downloadDataFooter).length > 0 ? "bold" : "normal"
        data.cell.styles.textColor =
          Object.keys(downloadDataFooter).length > 0 ? [247, 247, 247] : [17, 18, 18]
      }
    },
    didDrawPage: function (data) { //set header and footer of apge
      data.settings.margin.top = 35;
      let startHead = 3
      doc.setFontSize(10)
      doc.setFont('helvetica', 'bold');
      doc.text(`${downloadFileheader.party} - [ ${downloadFileheader.company} ]`, startHead, 10)

      doc.text(`${reportTitle ?? ""}`, startHead, 17)
      doc.setFont('times', 'normal');
      doc.setFontSize(9)
      doc.text(`ADDRESS : ${downloadFileheader.address && downloadFileheader.address != null && downloadFileheader.address.length > 0 ?
        funGetSubString(downloadFileheader.address ?? " ", 100).toUpperCase() : ""}`, startHead, 23)

      if (downloadBillDetail && downloadBillDetail.length > 0) {

        downloadBillDetail.map((item) => {
          doc.setFont('helvetica', 'bold')
          doc.setFontSize(9)
          doc.setTextColor(243, 18, 96, 1);
          doc.text(`${item.key.toUpperCase()}: ${item.value}`, startHead, 30)
          startHead += 75 //85
          return 0;
        })
      }
      //footer
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize?.height ? pageSize?.height : pageSize.getHeight();
      doc.text(
        'Page ' + data.pageNumber,
        data.settings.margin.left,
        pageHeight - 3
      );
    }


  })
  doc.save(`${downloadFileName}.pdf`)
}
//outstanding Report
const exportOutStandingReportToPDF = ({
  data,
  downloadFileName = "",
  exportColumns,
  reportTitle = "",
  downloadBillDetail = {},
  downloadFileheader = [],
  downloadDataFooter = {},
}) => {
  const doc = new jsPDF()

  //doc.setFontSize(10)
  let startX = 8
  //let startY = 30
  //let gapY = 8


  if (data && data.length > 0) {
    let lastY = 30
    for (let i = 0; i < data.length; i++) {

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9)
      doc.text(`BROKER : ${data[i].broker ?? ""}`, startX, i == 0 ? lastY : lastY + 10)
      doc.setFont('times', 'normal');
      let exportData = getExportData({ data: data[i].invoice, exportColumns })
      exportData = addDataFooter({ tempData: exportData, downloadDataFooter: data[i].footerData })



      /* creating column list */
      const colummArray = createColumnArray({ data: exportData })
      /* copy data as array of array */
      const dataArray = convertToNestedArray({ data: exportData })

      autoTable(doc, {
        theme: "striped",
        body: dataArray,
        head: [colummArray.map(name => name.toUpperCase())],//[colummArray],
        margin: startX,
        tableWidth: 200,
        startY: i == 0 ? lastY + 3 : lastY + 15,
        gapY: 20,
        styles: {
          fontSize: 8,
          cellWidth: "auto",// colummArray.length > 4 ? (colummArray.length > 8 ? 17 : 23) : 45,
          overflow: "linebreak",
          lineWidth: 0.1,
          lineColor: [200, 200, 200]
          // marginTop: 10,
          // fontSize: 9,

        },

        columnStyles: {
          0: { cellWidth: 20, halign: "center" },
          1: { cellWidth: colummArray.length == 9 ? 26 : 20, halign: "center" },
          2: { cellWidth: colummArray.length == 9 ? 25 : 20, halign: "right" },
          3: { cellWidth: colummArray.length == 9 ? 25 : 20, halign: "right" },
          4: { cellWidth: colummArray.length == 9 ? 25 : 20, halign: "right" },
          5: { cellWidth: 15, halign: "center" },
          6: { cellWidth: 20, halign: "center" },
          7: { cellWidth: 20, halign: "center" },
          8: { cellWidth: 20, halign: "center" },
          9: { cellWidth: 20, halign: "center" },
          text: { cellWidth: "wrap" }
        },
        headStyles: {
          fillColor: [255, 255, 255],// : [(107, 114, 128)],
          fontSize: 7,
          halign: 'center',
          fontStyle: 'bold',
          textColor: [0, 0, 0],
          // fillColor: [46, 128, 186],
          // fontSize: 9,
          // textColor: [247, 247, 247]

        },
        didParseCell: function (data) {
          if (data.row.index === dataArray.length - 1) {
            data.cell.styles.fillColor =
              //  Object.keys(data[i].footerData ).length > 0
              // ?
              //[46, 128, 186]
              [255, 255, 255]
            data.cell.styles.fontStyle =
              //  Object.keys(data[i].footerData).length > 0 ?
              "bold"
            // : "normal"
            data.cell.styles.textColor = [0, 0, 0]
            //Object.keys(data[i].footerData).length > 0 ?
            // [247, 247, 247]
            //: [17, 18, 18]
          }
        },
        didDrawPage: function (data) { //set header and footer of apge
          data.settings.margin.top = 27;
          let startHead = 8
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10)
          doc.text(`${funGetSubString(downloadFileheader.company ?? "", 100)}`, startHead, 10)
          doc.text(`${reportTitle}`, startHead, 17)
          doc.setFont('times', 'normal');
          doc.setFontSize(9)
          doc.text(`ADDRESS : ${downloadFileheader.address && downloadFileheader.address != null && downloadFileheader.address.length > 0 ?
            funGetSubString(downloadFileheader.address ?? " ", 97).toUpperCase() : ""}`, startHead, 23)

          // if (downloadBillDetail && downloadBillDetail.length > 0) {
          // downloadBillDetail.map((item) => {
          //   doc.fontStyle = "bold";
          //   doc.fontSize = "13"
          //   doc.setTextColor(243, 18, 96, 1);
          //   doc.text(`${item.key.toUpperCase()}: ${item.value}`, startHead, 25)
          //   startX += 85 //65

          // })

          // }
          //footer
          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(
            'Page ' + data.pageNumber,
            data.settings.margin.left,
            pageHeight - 3
          );
        },



      })
      lastY = doc.lastAutoTable.finalY;

    }
  }
  else {

    doc.text(`Data  Not Found`, 30, 50)
  }

  doc.save(`${downloadFileName}.pdf`)
}

//ledger Report
const exportLedgerReportToPDF = ({
  data,
  downloadFileName = "",
  exportColumns,
  downloadFileheader = [],
  downloadDataFooter = {},
}) => {
  let startX = 5
  let newData = data

  newData = data.map((ele, index) => {
    if (ele.Debit == 0)
      return { ...ele, Debit: "", }
    if (ele.Credit == 0)
      return { ...ele, Credit: "" }

  })


  let exportData = getExportData({ data: newData, exportColumns })
  exportData = addDataFooter({ tempData: exportData, downloadDataFooter })

  const doc = new jsPDF()

  /* creating column list */
  const colummArray = createColumnArray({ data: exportData })
  /* copy data as array of array */
  const dataArray = convertToNestedArray({ data: exportData })

  doc.setFontSize(16)
  let startY = 10
  let gapY = 10

  let headCompName = "";
  let headPartyName = "";
  let headDate = "";
  let headCompAdd = "";
  let headPartyAdd = "";
  let headCompPanNo = "";
  let headPartyPanNo = "";


  if (downloadFileheader.length > 0) {

    downloadFileheader.map((item, index) => {
      if (item.key == "Head") {
        headCompName = item.val1.toUpperCase()
        headPartyName = item.val2.toUpperCase()
        headCompAdd = item.val3 ?? ""
        headPartyAdd = item.val4 ?? ""
        headCompPanNo = item.val5 ?? ""
        headPartyPanNo = item.val6 ?? ""

      }
      else if (item.key == "Date") {
        headDate = `Ledger For Period  ${item.value}`;
      }
      return 0;
    })
  }


  startY = 40;
  gapY = 8

  doc.setFontSize(10)

  let lastY = 5


  const headerArray = [
    {
      col1: headCompName,
      col2: "PAN NO : " + headCompPanNo,
      col3: headCompAdd ?? ""
    },
    {
      col1: "LEDGER FOR ACCOUNT - " + headPartyName,
      col2: "PAN NO : " + headPartyPanNo,
      col3: headPartyAdd
    }
  ]


  autoTable(doc, {
    theme: "grid",
    body: dataArray,
    head: [colummArray.map(name => name.toUpperCase())],// [colummArray],
    tableWidth: 200,
    margin: startX,
    startY: startY,
    styles: {
      fontSize: 8,
      cellWidth: "auto",// colummArray.length > 4 ? (colummArray.length > 8 ? 17 : 23) : 45,
      overflow: "linebreak",
      lineWidth: 0.1,
      lineColor: [200, 200, 200]
    },
    columnStyles: {
      0: { cellWidth: 20 },
      1: { cellWidth: 30 },
      2: { cellWidth: 22 },
      3: { cellWidth: 25, halign: "right" },
      4: { cellWidth: 25, halign: "right" },
      5: { cellWidth: 25, halign: "right" },
      7: { cellWidth: 42, fontSize: 7, overflow: 'linebreak' },
      6: { cellWidth: 10 },
    },

    // overflow: 'linebreak',
    headStyles: {
      fillColor: [255, 255, 255],// : [(107, 114, 128)],
      fontSize: 7,
      halign: 'center',
      fontStyle: 'bold',
      textColor: [0, 0, 0],
      // fillColor: [46, 128, 186],
      // fontSize: 10,
      // halign: 'center',
      // textColor: [247, 247, 247]
    },
    didParseCell: function (data) {
      if (data.row.index === dataArray.length - 1) {
        data.cell.styles.fillColor =
          Object.keys(downloadDataFooter).length > 0
            ? [255, 255, 255]// [46, 128, 186]
            : [255, 255, 255]
        data.cell.styles.textColor = [0, 0, 0]// [247, 247, 247]
        data.cell.styles.fontStyle =
          Object.keys(downloadDataFooter).length > 0 ? "bold" : "normal"
      }
    },

    didDrawPage: function (data) { //set header and footer of apge
      data.settings.margin.top = 40;
      headerArray.map((item, index) => {

        doc.setFontSize(8)
        doc.setFont('helvetica', 'bold');
        doc.text(funGetSubString(item.col1, 90), startX + 3, index == 0 ? 8 : 23)
        doc.setFontSize(9)
        doc.setFont('times', 'normal');
        doc.text(funGetSubString(item.col3, 107), startX + 3, index == 0 ? 13 : 28)
        doc.text(funGetSubString(item.col2, 90), startX + 3, index == 0 ? 18 : 33)

      })
      doc.setFont('helvetica', 'bold');
      doc.text(headDate, 70, 37)//25


      //footer
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(
        'Page ' + data.pageNumber,
        data.settings.margin.left,
        pageHeight - 5
      );
    },
  })


  doc.save(`${downloadFileName}.pdf`)
}


//grid export Report
const exporGridToPDF = ({
  data,
  downloadFileName = "",
  exportColumns,
  exportReportType,
  downloadFileheader = [],
  downloadDataFooter = {},
  companyName = [],
}) => {
  let startX = 10
  let newData = data

  let exportData = getExportData({ data: newData, exportColumns })
  exportData = addDataFooter({ tempData: exportData, downloadDataFooter })

  const doc = new jsPDF()
  //console.log(downloadDataFooter,"iu",exportColumns)
  /* creating column list */
  const colummArray = createColumnArray({ data: exportData })
  /* copy data as array of array */
  const dataArray = convertToNestedArray({ data: exportData })


  let startY = 18
  let gapY = 10


  doc.setFontSize(10)



  autoTable(doc, {
    theme: "striped",
    body: dataArray,
    head: [colummArray.map(name => name.toUpperCase())],//; [colummArray],
    tableWidth: doc.internal.pageSize.getWidth() - 20,
    margin: startX,
    startY: startY,
    styles: {
      fontSize: 8,
      cellWidth: 'auto',// colummArray.length > 4 ? (colummArray.length > 8 ? 17 : 23) : 45,
      overflow: "linebreak",
      lineWidth: 0.1,
      lineColor: [200, 200, 200]
    },
    columnStyles:
      { text: { cellWidth: "wrap" } },
    overflow: 'linebreak',
    headStyles: {
      fillColor: [255, 255, 255],// : [(107, 114, 128)],
      fontSize: 7,
      halign: 'center',
      fontStyle: 'bold',
      textColor: [74, 72, 72],

      // fillColor: [93, 190, 157],// : [(107, 114, 128)],
      // fontSize: 10,
      // halign: 'center',
      // textColor: [247, 247, 247] //isLedger?
    },
    overflow: "linebreak",
    didParseCell: function (data) {
      if (data.row.index === dataArray.length - 1) {
        data.cell.styles.fillColor =
          Object.keys(downloadDataFooter).length > 0
            ? [255, 255, 255]//[72, 73, 74] // [93, 190, 157]
            : [255, 255, 255]
        data.cell.styles.textColor = [74, 72, 72] //247
        data.cell.styles.fontStyle =
          Object.keys(downloadDataFooter).length > 0 ? "bold" : "normal"
      }
    },

    didDrawPage: function (data) { //set header and footer of apge

      //header
      if (exportReportType == "MixStock") {
        data.settings.margin.top = 15;

        downloadFileheader.map((item, index) => {
          doc.setFontSize(10)
          doc.text(` ${item.value}`, startX, 10)

        })
        doc.setFontSize(12)
        doc.text(`${downloadFileName.split("_").join(" ")}`, startX, 15)
      }
      else {
        data.settings.margin.top = 18;
        doc.setFontSize(9)
        doc.text(`${companyName.join(",")}`, startX, 10)


        doc.setFontSize(10)
        doc.text(`- ${downloadFileName.split("_").join(" ")}`, startX, 15)
        // data.settings.margin.top = 13;
        // doc.setFontSize(12)
        // doc.text(`${downloadFileName.split("_").join(" ")}`, startX, 15)

        if (downloadFileheader.length > 0) {
          gapY = 14
          downloadFileheader.map((item, index) => {
            doc.setFontSize(10)
            doc.text(`${item.key}: ${item.value}`, startX + 3, gapY)
            // startY += 7;
            gapY += 2;
            return 0
          })
        }
      }
      //footer
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(
        'Page ' + data.pageNumber,
        data.settings.margin.left,
        pageHeight - 5
      );

    },
  })


  doc.save(`${downloadFileName}.pdf`)
}


function selectFilter({ data, conditions }) {
  //input
  //  conditions = { type: "orange", mnth: "june" }
  //  filteredData = filterData(data, conditions)
  return data?.filter((item) => {
    for (let key in conditions) {
      if (conditions[key]) {
        if (item[key] !== conditions[key]) {
          return false
        }
      }
    }
    return true
  })
}

function getUniqueValues({ data, key }) {
  // let uniqueTypes = getUniqueValues(data, "type")
  return [...new Set(data.map((item) => item[key]))]
}

function calculateTotalByKey({ data, columnNames, keyColumn }) {
  // Create an object to store aggregated data
  let result = {}

  // Iterate over the data array
  data.forEach((item) => {
    let key = item[keyColumn]

    // If key is not present in the result object, initialize it
    if (!result[key]) {
      result[key] = {}
      columnNames.forEach((column) => {
        result[key][column] = 0
      })
    }

    // Aggregate values
    columnNames.forEach((column) => {
      result[key][column] += item[column]
    })
  })

  // Convert the result object to an array
  let output = Object.entries(result).map(([key, value]) => ({
    [keyColumn]: key,
    ...value,
  }))

  return output
}

export const getMonthNamesBetween = (startDateStr, endDateStr) => {
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  const months = [];

  // Normalize start date to the first of the month
  start.setDate(1);
  end.setDate(1);

  while (start <= end) {
    const monthName = start.toLocaleString('default', { month: 'long' }); // e.g., "January"
    const year = start.getFullYear();

    months.push(`${monthName}`);

    // Move to next month
    start.setMonth(start.getMonth() + 1);
  }

  return months;
}


export {
  PivotDataSummary,
  pivotData,
  capitalize,
  exportToCSV,
  exportToPDF,
  exportToExcel,
  exportToExcelWithFilter,
  calculateTotal,
  calculateTotalWeight,
  createColumnArray,
  convertToNestedArray,
  exportInterestReportToPDF,
  exportOutStandingReportToPDF,
  exportLedgerReportToPDF,
  /* filter select */
  selectFilter,
  getUniqueValues,
  /* calculate total by columnName */
  calculateTotalByKey,
  filterKeys,
  PivotAgingPartyWise,
}


